.div_price {
	width: 30%;
	font-size: 13px;
	align-items: center;
	display: flex;
	flex-direction: column;
}

.style_table {
	height: 80%;

	@media screen and (max-width: 1500px) {
		height: 75%;
	}

	.style_table_title {
		width: 100%;
		text-align: center;
		margin-top: 10px;

		.table_th {
			font-size: 13px;

			@media screen and (max-width: 1500px) {
				font-size: 12px;
			}
		}
	}

	.style_table_body {
		width: 100%;
		background-color: #fafafa;
		border-radius: 5px;
		font-size: 12px;
		text-align: center;
		margin-top: 10px;

		@media screen and (max-width: 1500px) {
			margin-top: 5px;
			font-size: 11px;
		}

		td {
			padding: 7px 0px;

			@media screen and (max-width: 1500px) {
				padding: 5px 0px;
			}
		}
	}
}
